<template>
    <div class="combatPage" id="js-page-combat">
        <header class="combat-head" v-if="recordInfo && recordInfo.userInfo">
            <div class="combat-base" id="js-combat-headBase">
                <header class="myHeader">
                    <div class="ta-center headerName">{{recordInfo.userInfo.nick}}的战绩</div>
                    <div class="headerMiddle">
                        <figure class="headPic"><img :src="recordInfo.userInfo.logo.thumb120"></figure>
                        <div class="headerGap"></div>
                        <figcaption class="headerNick">{{recordInfo.userInfo.nick}}</figcaption>
                    </div>
                    <div class="headerBottom">
                        <div class="headBotSecOne inlineBlock">
                            <h1 class="goldNum"><k-num :value="recordInfo.totalIncome||0" :sign="true" style="color:white;"></k-num></h1>
                            <figure class="headBotPic"><img src="//staticcdn-prd.pydp888.com/award/updown2016/v1/img/mycombat/hdsy.png">
                                <figcaption class="headBotPicCon">活动收益(金币)</figcaption>
                            </figure>
                        </div>
                        <figure class="headShuOne inlineBlock"><img src="//staticcdn-prd.pydp888.com/award/updown2016/v1/img/mycombat/whiteline_102h.png"></figure>
                        <div class="headBotSecTwo  inlineBlock headBotMid">
                            <h1 class="goldNum"><span>{{recordInfo.userTotalIncomeRank||0}}</span></h1>
                            <figure class="headBotPic"><img src="//staticcdn-prd.pydp888.com/award/updown2016/v1/img/mycombat/gsbpm.png">
                                <figcaption class="headBotPicCon">股神排行榜</figcaption>
                            </figure>
                        </div>
                        <figure class="inlineBlock headShuTwo"><img src="//staticcdn-prd.pydp888.com/award/updown2016/v1/img/mycombat/whiteline_102h.png"></figure>
                        <div class="headBotSecThr  inlineBlock">
                            <h1 class="goldNum"><span>{{recordInfo.historyUnbrokenMaxWin||0}}</span></h1>
                            <figure class="headBotPic"><img src="//staticcdn-prd.pydp888.com/award/updown2016/v1/img/mycombat/zgls.png">
                                <figcaption class="headBotPicCon">最高连胜(场)</figcaption>
                            </figure>
                        </div>
                    </div>
                </header>
            </div>
        </header>
        <div class="combat-body" id="js-combat-body"  v-if="recordInfo">
            <div class="perNumPart" id="js-combat-one">
                <div class="my-middle">
                    <div class="myConTop">
                        <div class="mySeason mySeasonOne">
                            <dl>
                                <dd>{{ recordInfo.totalInvolve || 0}}</dd>
                                <dt>总场次</dt>
                            </dl>
                        </div>
                        <div class="mySeason mySeasonTwo">
                            <dl>
                                <dd>{{ recordInfo.pTotalWin || 0}}</dd>
                                <dt>胜利场次</dt>
                            </dl>
                        </div>
                        <div class="mySeason mySeasonThr">
                            <dl>
                                <dd>{{(recordInfo.totalInvolve-recordInfo.pTotalWin) || 0}}</dd>
                                <dt>失败场次</dt>
                            </dl>
                        </div>
                    </div>
                    <div class="myConGap"></div>
                    <div class="myConMiddle">
                        <h1 class="myConMiddleTitle">他的胜率
                            <k-rate :value="(recordInfo.pTotalWin/recordInfo.totalInvolve) || 0"></k-rate>
                        </h1></div>
                    <div class="myConMidVs">
                        <div class="myVsLeft">
                            <p class="myVsLeftCon"><span class="myVsWinCon">胜</span><span class="myVsWinNum">{{recordInfo.pTotalWin||0}}</span></p>
                        </div>
                        <div class="myVsMiddle"><img src="//staticcdn-prd.pydp888.com/award/updown2016/v1/img/mycombat/wdzjvs.png" width="100%"></div>
                        <div class="myVsRight">
                            <p class="myVsRightCon"><span class="myVsLoseCon">负</span><span class="myVsLoseNum">{{(recordInfo.totalInvolve||0)-(recordInfo.pTotalWin||0)}}</span></p>
                        </div>
                    </div>
                </div>
                <div class="pd-sm">
                    <van-divider :style="{ padding: '0 16px' }">本周盈利</van-divider>
                    <div>
                        <van-cell title="本周盈利">
                            <!-- 使用 title 插槽来自定义标题 -->
                            <template slot="default">
                                <span class="cl-red">{{recordInfo.wTotalIncome}}</span> 金币
                            </template>
                        </van-cell>
                        <van-cell title="本周盈利排名">
                            <!-- 使用 title 插槽来自定义标题 -->
                            <template slot="default">
                                <span class="cl-red">{{recordInfo.userWeekIncomeRank}}</span> 名
                            </template>
                        </van-cell>
                    </div>
                </div>
            </div>                                
        </div>
    </div>
</template>
<script>
    import {mapActions, mapGetters} from 'vuex'
    import {WZ} from '../../common/globals'
    export default {
        data() {
            return {
                uid : this.$route.query.uid || 0
            }
        },
        components:{
            // 'mycombat-list' : MyCombatList,
            // 'mycombat-info' : MyBetInfo,
        },
        computed: {
            ...mapGetters('mybet', ['betList','recordInfo']),
            ...mapGetters('home', ['transDate', 'nowTime', 'tomorrow', 'todayIsTransdate', 'myBetInfo']),
        },
        methods: {
            ...mapActions('mybet', ['loadMyBetList','loadMytRecordInfo']),
            ...mapActions('home', ['loadBetinfo', 'loadTansdateList']),
            goLogin(){
                WZ.go('login',{})
            },
            async load (){
                const {uid,todayIsTransdate,nowTime,tomorrow} = this
                let dataStandardFormat = null
                if(todayIsTransdate == 1){
                    dataStandardFormat = nowTime.years + '-' + nowTime.months + '-' + nowTime.days
                }else{
                    dataStandardFormat = tomorrow.years + '-' + tomorrow.months + '-' + tomorrow.days
                }
                if(!uid) return
               /*  this.loadBetinfo({
                    transDate : dataStandardFormat
                })
                this.loadMyBetList({
                    uid : uid,
                    start : 0,
                    pageNum : 50,
                    rewardFlag: 1,
                    beforeId : 0,
                    afterId : 0,
                }) */
                this.loadMytRecordInfo({
                    uid : uid,
                })
            }
        },
        created() {
            
        },
        async mounted() {
            if(!this.transDate){
                await this.loadTansdateList()
                setTimeout(()=>{
                    this.load()
                },200)
            } else {
                setTimeout(()=>{
                    this.load()
                },200)
            }            
        },
        watch: {
            /* myUid(n) {
                if(!n) {
                    this.$dialog.confirm({
                        title: '登录提示',
                        message: '大侠还没登录呢！',
                        confirmButtonText: '登录'
                    }).then(() => {
                        // on confirm
                        WZ.go('login',{})

                    }).catch(() => {
                        // on cancel
                    })
                }
            } */
        }
    }
</script>